import { LayoutRenderer, RowCollectionLayout } from './types';
import { HeroTwoLayout } from './HeroTwoLayout';
import { WideGridLayout } from './WideGridLayout';
import {
  GridSixLayout,
  GridTwoByTwoLayout,
  RowFiveLayout,
  RowSixLayout,
  RowThreeLayout,
  TallGridTwoByTwoLayout,
} from './GridStubLayouts';
import { HeroOneLayout } from './HeroOneLayout';

export const layoutRegistry: Partial<Record<RowCollectionLayout, LayoutRenderer>> = {
  'hero-1': HeroOneLayout,
  'hero-2': HeroTwoLayout,
  'wide+grid3x3': WideGridLayout,
  'row-3': RowThreeLayout,
  'row-5': RowFiveLayout,
  'row-6': RowSixLayout,
  'grid-6': GridSixLayout,
  'grid-2x2': GridTwoByTwoLayout,
  'tall+grid2x2': TallGridTwoByTwoLayout,
};
